import * as React from "react";
import MuiDialog, {
    DialogProps as MuiDialogProps,
    DialogClassKey as MuiDialogClassKey
} from "@material-ui/core/Dialog";

export type DialogClassKey = MuiDialogClassKey;

export interface DialogProps extends MuiDialogProps { }

class Dialog extends React.PureComponent<DialogProps> {
    render() {
        const { ...props } = this.props;
        return <MuiDialog {...props}>
            {this.props.children}
        </MuiDialog>;
    }
}

export default Dialog;